import AdminStoreList from './AdminStoreList';
export default AdminStoreList;
